module.exports = __webpack_public_path__ + "media/img/Landing_Page/f2f-session-eb8794565951765a8a9837f9a010b324.png";